import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/icon'
import { Button } from '@/components/ui'
import { AtendimentoDropdownMenu } from '@/features/atendimento/shared/components/atendimento-dropdown'
import { useAtendimento } from '@/hooks/use-atendimento'
import { useCountryNavigate } from '@/hooks/use-localized-navigate'
import type { TClienteBrasil } from '@/types/atendimento'

export const AtendimentoTrigger = () => {
  const { t } = useTranslation('atendimento')
  const navigate = useCountryNavigate()
  const { atendimento } = useAtendimento()
  if (atendimento?.id) return <AtendimentoDropdownMenu cliente={atendimento.cliente as TClienteBrasil} />

  return (
    <Button
      variant="secondary"
      className="font-nunito shadow-cz bg-white font-semibold text-neutral-700"
      onClick={() => navigate('/atendimento/iniciar')}
    >
      <>
        <Icon name="square-play" className="text-neutral-400" size={20} />
        {t('iniciar_atendimento')}
      </>
    </Button>
  )
}
